import { Error } from "api/baseApiResponseModel/BaseApiResponseModel";
import { LoginRequestModel } from "api/repositories/authentications/model/LoginRequestModel";
import { LoginResponseModel } from "api/repositories/authentications/model/LoginResponseModel";
import { BaseViewModel } from "components/base/BaseViewModel";
import { isEmpty } from "lodash";
import { BehaviorSubject } from "rxjs";
import { injectable } from "tsyringe";
import { CacheKeyEnum } from "utils/enums/CacheKeyEnum";
import { ServiceRepo } from "utils/serviceRepo/ServiceRepo";

class LoginInput implements Disposable {
  public login = new BehaviorSubject<LoginRequestModel>({});
  public loading = new BehaviorSubject<boolean>(false);

  [Symbol.dispose](): void {
    this.login.complete();
    this.loading.complete();
  }
}

class LoginOutput implements Disposable {
  public onLoginSuccess = new BehaviorSubject<boolean>(false);
  public onError = new BehaviorSubject<Error>({});

  [Symbol.dispose](): void {
    this.onLoginSuccess.complete();
    this.onError.complete();
  }
}

@injectable()
export class LoginViewModel extends BaseViewModel<LoginInput, LoginOutput> {
  constructor() {
    super(new LoginInput(), new LoginOutput());
  }

  protected override transform(): void {
    this.input.login
      .subscribe(async (body) => {
        if (isEmpty(body)) {
          return;
        } else {
          try {
            this.input.loading.next(true);
            let isSavedForNextLogin = body?.isSavedForNextLogin;
            localStorage.setItem(
              "isSavedForNextLogin",
              `${isSavedForNextLogin}`
            );
            delete body?.isSavedForNextLogin;
            const repo = ServiceRepo.getAuthenRepo();
            const { data } = await repo.login(body);
            if (data) {
              let finalData = data as LoginResponseModel;
              isSavedForNextLogin
                ? localStorage.setItem(
                    CacheKeyEnum.mainToken,
                    finalData?.accessToken.id
                  )
                : sessionStorage.setItem(
                    CacheKeyEnum.mainToken,
                    finalData?.accessToken?.id
                  );
              delete finalData.accessToken;
              this.output.onLoginSuccess.next(true);
            }
          } catch (error) {
            console.error(error);
            this.output.onError.next(error);
          } finally {
            this.input.loading.next(false);
          }
        }
      })
      .add(this.subscriptions);
  }
}
